import { render, staticRenderFns } from "./KeyTwenty.vue?vue&type=template&id=36d33ca0&scoped=true&"
import script from "./KeyTwenty.vue?vue&type=script&lang=js&"
export * from "./KeyTwenty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d33ca0",
  null
  
)

export default component.exports